<template>
  <div style="padding-bottom: 10px">
    <div class="row">
      <div class="col-md-2">
        <p>
          ТСР <i v-on:click="hide" class="tim-icons icon-minimal-up"></i>
        </p>
      </div>
      <div class="col-md-10">
        <p>
          Новый ТСР
          <i v-on:click="newCall" class="tim-icons icon-chat-33"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" :a-page="true" :hide-pages="true" :page-limits="pageLimits" :tuning="false"
             :new-one="newOne"
             :default-sort="date" :default-sort-direction="false"
             @resetNew="newOne = null"></big-one>
  </div>
</template>
<script>

import {
  BaseInput,
  Card
} from "@/components/index";

import {sorter} from "@/services/utils";
import {authHeader} from "@/services/auth-header";
import {userService} from "@/services/user.service";

const tsrBaseTsrName = {header: "Наименование", name: "basis.name", show: true, contains: ""};
const tsrNextDate = {header: "Следующая дата", name: "nextDate", show: true, sort: true};
const tsrIprClient = {header: "Клиент", name: "ipr.client.name", show: true};

export default{
  components:{
    Card,
    BaseInput
  },
  props:{
    item: {}
  },
  data() {
    return {
      content: [tsrBaseTsrName, tsrNextDate, tsrIprClient],
      type: "tsr",
      pageLimits: {ipr: this.item.id},
      newOne: null
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    newCall() {
      let object = {ipr: this.item, id: 0};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  }
}
</script>
<style>
</style>
